// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb__kQzIq","item":"item__sLTKS","itemLink":"itemLink__UPA5D","separator":"separator__DKxoT"};